import { Select, Typography } from 'antd'
import { useDrilldownSchema } from 'features/drilldown/rolodex/DrilldownDataSchema'
import { DrilldownRolodexType } from 'features/drilldown/rolodex/ontology/ontologyTypes'
import { OptionalValueSetterPair } from 'features/drilldown/utils/valueSetterPair'
import { FC, useEffect, useMemo } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`

const { Text } = Typography

type SchemaTypeSelectProps = OptionalValueSetterPair<
  DrilldownRolodexType,
  'selectedType'
> & { label: string }

// TODO(xdowns): merge this with the schema type select in bulk edit
export const SchemaTypeSelect: FC<SchemaTypeSelectProps> = ({
  selectedType,
  setSelectedType,
  label,
}) => {
  const { entryTypeNames } = useDrilldownSchema()
  useEffect(
    () =>
      setSelectedType?.((prev) =>
        Object.keys(entryTypeNames).includes(prev)
          ? prev
          : Object.keys(entryTypeNames)[0]
      ),
    [entryTypeNames, setSelectedType]
  )
  const options = useMemo<ReadonlyArray<{ value: string; label: string }>>(
    () =>
      Object.entries(entryTypeNames).map(([type, name]) => ({
        value: type,
        label: name,
      })),
    [entryTypeNames]
  )

  return (
    <Container>
      <Text>{label}: </Text>
      <Select
        style={{ width: '300px' }}
        value={selectedType}
        onChange={setSelectedType}
        disabled={!setSelectedType}>
        {options.map(({ value, label }) => (
          <Select.Option key={value} value={value}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </Container>
  )
}
